// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b9bbdc82f5118242cf335fafccb44592b9aef7bc';
export const BUILD_NUMBER = '261';
export const BUILD_TIMESTAMP = '2026-10-06T10:33:59.495Z';
